import type { BaseSelectionItem } from "@trydig/centra-types/selection";
import type { RGProduct } from "../types";

export const getFirstImage = (item: BaseSelectionItem) => {
	const mediaData = Object.keys(item?.product?.media || {});

	const media = mediaData?.map((key) => {
		return { href: item?.product?.media?.[key]?.[0] as string, alt: "" };
	});
	if (!media) return null;
	return media;
};

export const getFirstThumbnail = (item: BaseSelectionItem): string => {
	const firstThumbnail = item?.product?.media?.["700x0"]?.[0];
	return firstThumbnail || "";
};

export const getRequiredYarns = (item: BaseSelectionItem) => {
	const offsetYarnCount = (yarns?: number | string) => {
		yarns = Number(yarns);
		if (isNaN(yarns)) return 4;
		// Centra requires us to have the Centra config set 1 higher than the actual amount of yarns required.
		// See https://frend-digital-as.slack.com/archives/C017YDGQ17Z/p1709278894858609?thread_ts=1709278133.435179&cid=C017YDGQ17Z
		return yarns - 1;
	};

	const requiredYarns = (item?.product as RGProduct)?.pr_yarns_required_value;
	return offsetYarnCount(requiredYarns);
};
